// External links surfaced in the UI. One source of truth so the GitHub URL
// in the App header, SelfHostNotice CTA, and quickstart all stay aligned.

export const REPO_URL = 'https://github.com/kiante-fernandez/survey-shield';

// Anchor on the README that the SelfHostNotice's "Self-host quickstart"
// button targets. GitHub renders `## Self-host the live runtime` as
// `#self-host-the-live-runtime`.
export const SELF_HOST_QUICKSTART_URL =
  `${REPO_URL}#self-host-the-live-runtime`;

// Canonical paper behind Survey Shield. Mirrors SURVEY_SHIELD_CITATION in
// surveyshield/review/reviewer.py — update both together.
export const PAPER_URL = 'https://ssrn.com/abstract=7221478';
export const PAPER_DOI_URL = 'https://doi.org/10.2139/ssrn.7221478';
export const PAPER_TITLE =
  'How Vulnerable Are Consumer Research Surveys to AI Agents? ' +
  'Validating an Instrument-Review Framework and Auditing Recent JCR ' +
  'Open Materials';
export const PAPER_APA =
  'Fernandez, K., Low, A., Bogard, J., & Fox, C. R. (2026). How ' +
  'vulnerable are consumer research surveys to AI agents? Validating an ' +
  'instrument-review framework and auditing recent JCR open materials. ' +
  'SSRN. https://doi.org/10.2139/ssrn.7221478';
